"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientIdFromChannel = exports.CHANNEL_CLIENT_ID_MAP = void 0;
const config_1 = __importDefault(require("next/config"));
const { serverRuntimeConfig = {} } = (0, config_1.default)();
const { authClientId, authB2BClientId, authB2CClientId } = serverRuntimeConfig;
exports.CHANNEL_CLIENT_ID_MAP = {
    B2B: authB2BClientId,
    B2C: authB2CClientId,
    B2C_ANONYMOUS: authClientId,
};
function getClientIdFromChannel(channel) {
    return exports.CHANNEL_CLIENT_ID_MAP[channel];
}
exports.getClientIdFromChannel = getClientIdFromChannel;
//# sourceMappingURL=getClientIdFromChannel.js.map